/**
 * Główna kolekcja errorów dla aplikacji
 */
angular.module('salesPath2').service('mainErrorCollection', ['ErrorCollectionModel',
  function (ErrorCollectionModel)
  {
    return new ErrorCollectionModel();
  }
]);